// noinspection ES6UnusedImports
import React from 'react';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';
import {Icon, Typography, Tooltip} from '@bonprix/design-system';

let tooltipOpenLandmarkSent;

const sendTooltipOpenLandmark = () => {
    if (!tooltipOpenLandmarkSent) {
        LandmarkAdapter.sendClickLandmark('delivery_costs_info');
        tooltipOpenLandmarkSent = true;
    }
};

export default function ShippingChargesSection({isParcelShopDeliveryPossible, texts, shippingCharges}) {
    const renderShippingChargesLabelOrTooltip = () => {
        if (isParcelShopDeliveryPossible) {
            const tooltipContent =
                <>
                    <Typography component="span">{texts.cot09_shipping_charges_info_layer}</Typography>
                    <span className="cart__order-shipping-costs-info-layer__line">
                        <div className="cart__order-shipping-costs-info-layer__line-label">
                            <Icon variant="home2" />
                            <Typography component="span">{texts.cot09_delivery_to_private_address}</Typography>
                        </div>
                        <div className="cart__order-shipping-costs-info-layer__line-price" align="right">
                            <Typography
                                component="span" align="right">{texts.cot09_delivery_to_address_shipping_charges}</Typography>
                        </div>
                    </span>
                    <span className="cart__order-shipping-costs-info-layer__line">
                        <div className="cart__order-shipping-costs-info-layer__line-label">
                            <Icon variant="location" />
                            <Typography component="span">{texts.cot09_delivery_to_parcelshop}</Typography>
                        </div>
                        <div className="cart__order-shipping-costs-info-layer__line-price" align="right">
                            <Typography
                                component="span" align="right">{texts.cot09_delivery_to_parcelshop_shipping_charges}</Typography>
                        </div>
                    </span>
                </>;

            return (

                <span className="cart__order-shipping-costs-tooltip-wrapper" onMouseEnter={sendTooltipOpenLandmark}>
                    <Tooltip content={tooltipContent}>
                        <span className={'flex gap-2'}>
                            <Typography component="span">{texts.cot09_versandkosten}</Typography>
                            <span aria-label="icon">
                                <Icon variant={'hint'} className={'h-5 w-5 inline'} />
                            </span>
                        </span>
                    </Tooltip>
                </span>
            );
        } else {
            return (
                <div className="cart__order-shipping-costs-label">
                    <Typography component="span">{texts.cot09_versandkosten}</Typography>
                </div>
            );
        }
    };

    return (
        <div className="cart__order-shipping-costs">
            {renderShippingChargesLabelOrTooltip()}
            <div className="cart__order-shipping-costs-price" test-ref__cart-order-shipping-costs-price="">
                <Typography variant="h4" component="div" align="right">
                    {shippingCharges}
                </Typography>
            </div>
        </div>
    );
}
